import { defaultGetResponse } from "../interfaces/ActionReducer/GetMethod/GetResponse";
import { WorkOrdersDataStateInterface } from "../actions/WorkOrders/types";
import { createReducer } from "@reduxjs/toolkit";
import {
    getWorkOrders,
    receivedWorkOrdersTableFilters,
    setSelectedWorkOrderColumns,
    setSelectedWorkOrderIds,
    setWorkOrdersParams,
    showWorkOrderListView,
    toggleWorkOrderActionPerformed,
    workOrdersReceived
} from "actions";
import { resetStateRTK } from "components/curb/ManagerAnalyzer/Toggle/commonUtilities";

const initialState: WorkOrdersDataStateInterface = {
    isFetchingWorkOrders: false,
    selectedWorkOrderIDs: [],
    selectedColumns: [],
    showWorkOrdersListView: false,
    toggleWorkOrderActionPerformed: false,
    workOrdersList: defaultGetResponse,
    workOrdersParams: {
        fields: ""
    },
    workOrdersTableFilters: []
};

const WorkOrders = createReducer(initialState, (builder) => {
    builder
        .addCase(showWorkOrderListView, (state, action) => {
            state.showWorkOrdersListView = action.payload.showWorkOrdersListView;
        })
        .addCase(setWorkOrdersParams, (state, action) => {
            state.workOrdersParams = action.payload.workOrdersParams;
        })
        .addCase(getWorkOrders, (state) => {
            state.isFetchingWorkOrders = true;
        })
        .addCase(workOrdersReceived, (state, action) => {
            state.isFetchingWorkOrders = false;
            state.workOrdersList = action.payload.workOrdersList;
        })
        .addCase(setSelectedWorkOrderColumns, (state, action) => {
            state.selectedColumns = action.payload.selectedColumns;
        })
        .addCase(setSelectedWorkOrderIds, (state, action) => {
            state.selectedWorkOrderIDs = action.payload.selectedWorkOrderIDs;
        })
        .addCase(toggleWorkOrderActionPerformed, (state) => {
            state.toggleWorkOrderActionPerformed = !state.toggleWorkOrderActionPerformed;
        })
        .addCase(receivedWorkOrdersTableFilters, (state, action) => {
            state.workOrdersTableFilters = action.payload.data;
        })
        .addCase(resetStateRTK, () => initialState)
        .addDefaultCase((state) => state);
});

export default WorkOrders;
